module.exports = __webpack_public_path__ + "img/yy.c0202f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/yy.png
// module id = rz3h
// module chunks = 17